// COLLECT-FLOWS: Setup › Structure › Collection at `/c/{slug}/setup/collection`: each person's
// collection session progress and what each role still waits for. Managers see everyone; a
// member sees their own sessions (the API cuts the list).
import { createRoute } from "@tanstack/react-router";
import { CollectionScreen } from "../features/flows/collection-screen";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupCollectionRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "collection",
  component: function Collection() {
    const { api } = setupCollectionRoute.useRouteContext();
    const company = useCompany();
    return <CollectionScreen api={api} company={company} />;
  },
});
